import { __cAuthService } from '@/services/client/__c.auth.service'
import { TResetPasswordBody } from '@/types/auth'
import { useMutation } from '@tanstack/react-query'

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationKey: ['reset-password'],
    mutationFn: async (body: TResetPasswordBody) => {
      const response = await __cAuthService.resetPassword(body)
      return response
    },
  })
}
